import React from "react";
import { Trans } from 'react-i18next';


const styles = {
	mepHeader:{
		color: 'rgb(0, 147, 128)',
		padding: 10,
		fontSize:'large',
		fontWeight:'bold'

	},
	mepContent: {
		margin:'10px 25px 35px 25px',

	}
};

const ContentMEP = ({release, lang}) => {
    const mep = Object.values(release)[0];
    
  return (
    <div > 
        <span style={styles.mepHeader}><Trans i18nKey="version.mep" /> {mep.date} (<Trans i18nKey="version.version" />: {mep.version})</span> 
        <div style={styles.mepContent}>
            {mep.new && mep.new.length > 0 &&(<div><b><Trans i18nKey="version.new" /></b></div>)}
            {mep.new?.map((i,  key) => (<div key={key}>- {i}</div>))}
            {mep.improved && mep.improved.length > 0 && (<div> <b><Trans i18nKey="version.improvements" /> </b></div>)}
            {mep.improved?.map((i,  key) => (<div key={key}>- {i}</div>))}
            {mep.bug && mep.bug.length > 0 &&(<div> <b><Trans i18nKey="version.bugs" /></b></div>)}
            {mep.bug?.map((bug,  key) => (<div key={key}>- {bug}</div>))}
            {mep.deprecated && mep.deprecated.length > 0 && (<div><b> <Trans i18nKey="version.deprecated" /> </b></div>)}
            {mep.deprecated?.map((i,  key) => (<div key={key}>{i}</div>))}
            {mep.removed && mep.removed.length > 0 && (<div><b><Trans i18nKey="version.removed" /> </b></div>)}
            {mep.removed?.map((i,  key) => (<div key={key}>- {i}</div>))}
        </div>  
    </div>

  );
}
export default ContentMEP;
